var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.035 34.035",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.81 21.2a.178.178 0 0 1-.241.065l-4.22-2.437a.337.337 0 0 1-.153-.265v-8.145c0-.097.08-.176.177-.176h1.411c.097 0 .177.08.177.176l-.001 7.127c0 .097.068.216.153.265l3.338 1.927a.176.176 0 0 1 .065.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.369 5.58c-6.408 0-11.621 5.213-11.621 11.621 0 6.409 5.213 11.622 11.621 11.622s11.622-5.213 11.622-11.622c0-6.408-5.214-11.621-11.622-11.621m0 25.007c-7.38 0-13.385-6.005-13.385-13.386 0-7.38 6.004-13.385 13.385-13.385s13.386 6.005 13.386 13.385c0 7.381-6.005 13.386-13.386 13.386"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.927d8f8feeab1a889e57a30d46bc4526.svg";
export { ForwardRef as ReactComponent };